import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  getErrorMessage() {
    const { error } = this.state;
    
    if (!error) return "Something went wrong, please refresh the page";
    
    // Check for specific error types
    if (error.message && error.message.includes('ze.split')) {
      return "Address search error: Please enter a complete address including street number and name";
    }
    
    if (error.message && error.message.includes('Google Maps')) {
      return "Google Maps error: Please refresh the page and try again";
    }
    
    if (error.message && error.message.includes('fetch')) {
      return "Network error: Please check your connection and try again";
    }
    
    return "Something went wrong, please refresh the page";
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-shi-eggshell">
          <div className="text-center p-8 max-w-md">
            <h1 className="text-2xl font-bold text-red-600 mb-4">Oops!</h1>
            <p className="text-gray-600 mb-6">{this.getErrorMessage()}</p>
            <button 
              onClick={() => window.location.reload()}
              className="bg-shi-green text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;